import { ParcelListActionTypes } from "parcel/screens/list/ParcelListActionTypes";
import { createActionCreator } from "common/ReduxUtils";

export const onParcelRowSelect = createActionCreator<number, boolean>(
  ParcelListActionTypes.SELECT_PARCEL_ROW,
  "index",
  "isChecked"
);
